require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-23-keyboard-shortcuts.json") })
        }
      }, "path---article-23-keyboard-shortcuts");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-23-keyboard-shortcuts!./.cache/json/article-23-keyboard-shortcuts.json
// module id = 538
// module chunks = 231608221292675